import { call, put, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { doShowLoading, doHideLoading, doShowResponse } from '../actions/ui';
import { fetchPlans, fetchPlansV2 } from '../api/plan';
import { doSavePlans, doSelectPlan } from '../actions/plan';
import { postMessageSender } from '../lib/postMessager';
import { getChannel } from '../selectors/session';
import messages from '../enum/messages';
import channels from '../constants/channels';
import { handleFetchClientBySession } from './fetchClient';

function* handleFetchPlans(action) {
  const { sessionId, selectedPlan } = action;
  const channel = yield select(getChannel);
  yield put(doShowLoading());
  try {
    const { data } = yield call(fetchPlans, sessionId);
    if (data.elegible) {
      yield put(doSavePlans(data.plans));
      if (selectedPlan && data.plans.find(p => p.codigo === selectedPlan)) {
        yield put(doSelectPlan(selectedPlan));
        yield call(handleFetchClientBySession, { payload: { sessionId, planCode: selectedPlan }});
        yield put(push('/pagamentoV2', { planAlreadySelected: true}));
      } else {
        yield put(push('/selecionar-plano'));
      }
    } else if ([channels.webauto, channels.webautoOneClickBuy].includes(channel)) {
      yield put(doShowResponse('error', messages.FE_003));
    } else {
      postMessageSender({ action: 'execute_failed', code: 'FE-003', reason: messages.FE_003 });
    }
  } catch (e) {
    postMessageSender({ action: 'execute_failed', code: 'FE-001', reason: messages.FE_001 });
  } finally {
    yield put(doHideLoading());
  }
}

function* handleFetchPlansV2(action) {
  const { sessionId, selectedPlan } = action;
  try {
    const headers = { headers: { 'x-api-key': process.env.REACT_APP_X_API_KEY_BFF }};

    const { data } = yield call(fetchPlansV2, sessionId, headers);
    yield put(doSavePlans(data.plans));
    const plan = data.plans.find(p => p.codigo === selectedPlan);
    if (plan) {
      yield put(doSelectPlan(plan));
    } else {
      yield put(push('/selecionar-plano'));
    }
  } catch (e) {
    postMessageSender({ action: 'execute_failed', code: 'FE-001', reason: messages.FE_001 });
  }
}

export { handleFetchPlans, handleFetchPlansV2 };
